export default __webpack_public_path__ + "static/media/architecture.e51abf40.png";